import React, {useContext, useEffect, useState} from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    DisabledContext,
    LeftRightContainer,
    SubTitle,
    Text
} from "toolbox-react-frontend-components";
import {route} from "ziggy-js";
import {useNavigate} from "react-router-dom";

const DashboardPage = () => {
    const navigate = useNavigate();

    const {
        disabled,
    } = useContext(DisabledContext);

    return (
        <>
            <LeftRightContainer
                leftSlot={(
                    <Card
                        noMargin={true}
                        className={'h-100'}
                    >
                        <CardHeader
                            leftSlot={(
                                <SubTitle
                                    title={'Edit Homepage'}
                                    noMargin={true}
                                />
                            )}
                            rightSlot={(
                                <Button
                                    label={'Edit'}
                                    disabled={disabled}
                                    onClick={() => navigate(route('admin.page.edit', {page: 1}, false))}
                                />
                            )}
                        />
                        <CardBody>
                            <Text>
                                Edit the text on the main page from here.
                            </Text>
                        </CardBody>
                    </Card>
                )}
                rightSlot={(
                    <Card
                        noMargin={true}
                        className={'h-100'}
                    >
                        <CardHeader
                            leftSlot={(
                                <SubTitle
                                    title={'Album Gallery'}
                                    noMargin={true}
                                />
                            )}
                            rightSlot={(
                                <Button
                                    label={'Gallery'}
                                    disabled={disabled}
                                    onClick={() => navigate(route('admin.album.index', undefined, false))}
                                />
                            )}
                        />
                        <CardBody>
                            <Text>
                                Upload new albums, edit & remove existing albums and alter the album ordering from here.
                            </Text>
                        </CardBody>
                    </Card>
                )}
            />
            <LeftRightContainer
                leftSlot={(
                    <Card
                        noMargin={true}
                        className={'h-100'}
                    >
                        <CardHeader
                            leftSlot={(
                                <SubTitle
                                    title={'Edit Settings'}
                                    noMargin={true}
                                />
                            )}
                            rightSlot={(
                                <Button
                                    label={'Edit'}
                                    disabled={disabled}
                                    onClick={() => navigate(route('admin.setting.index', undefined, false))}
                                />
                            )}
                        />
                        <CardBody>
                            <Text>
                                Edit the site settings (mainly used for SEO and social links) here.
                            </Text>
                        </CardBody>
                    </Card>
                )}
            />
        </>
    );
}

export default DashboardPage;
